import { cloneDeep } from "lodash";
import { computed, ref } from "vue";

export const useShowColumns = (
  possibleColumns: Array<{ key: string; name: string }>,
  columnsNotToDisplayAtLoad: string[],
) => {
  const allPossibleColumns = ref(cloneDeep(possibleColumns));
  const hiddenColumns = ref<string[]>([]);

  const displayableColumns = ref<string[]>(
    possibleColumns.map<string>((val) => val.key).filter((value) => !columnsNotToDisplayAtLoad.includes(value)),
  );

  const canDisplayColumn = (columnKey: string): boolean => displayableColumns.value.includes(columnKey);

  const columnOptions = computed(() =>
    allPossibleColumns.value.filter((value) => !hiddenColumns.value.includes(value.key)),
  );

  const setHiddenColumns = (newVal: string[]): void => {
    hiddenColumns.value = newVal;
  };

  return {
    displayableColumns,
    canDisplayColumn,
    columnOptions,
    setHiddenColumns,
  };
};
